// extracted by mini-css-extract-plugin
export default {"title":"Style_title__AoSBa","w100":"Style_w100__UkIBa","wrapper":"Style_wrapper__CMl13","fontBold":"Style_fontBold__8Xaqe","buttons":"Style_buttons__LaGZ3"};